import Vue from "vue";
import {
  ValidationProvider,
  ValidationObserver,
  configure,
  extend,
} from "vee-validate";
import {
  required,
  email,
  between,
  image,
  integer,
  numeric,
  max,
  min,
  confirmed,
} from "vee-validate/dist/rules";

extend("required", {
  ...required,
  message: "Vui lòng nhập {_field_}",
});
extend("required-en", {
  ...required,
  message: "{_field_} is required",
});
extend("required-select", {
  validate(value) {
    return (
      value !== "" &&
      value !== 0 &&
      value !== null &&
      value !== {} &&
      value !== "undefined" &&
      typeof value !== "undefined"
    );
  },
  message: "Vui lòng lựa chọn {_field_}",
  computesRequired: true,
});
extend("required-select-en", {
  validate(value) {
    return (
      value !== "" &&
      value !== 0 &&
      value !== null &&
      value !== {} &&
      value !== "undefined" &&
      typeof value !== "undefined"
    );
  },
  message: "Please choose {_field_}",
  computesRequired: true,
});
extend("email", {
  ...email,
  message: "{_field_} không đúng định dạng",
});
extend("between", {
  ...between,
  params: ["min", "max"],
  message: "{_field_} phải nằm trong khoảng {min} đến {max}",
});
extend("image", {
  ...image,
  message: "{_field_} phải là hình ảnh",
});
extend("integer", {
  ...integer,
  message: "{_field_} là trường nhập số nguyên",
});
extend("numeric", {
  ...numeric,
  message: "{_field_} là trường nhập số",
});
extend("max", {
  ...max,
  params: ["max"],
  message: "{_field_} có giá trị tối đa {max}",
});
extend("min", {
  ...min,
  params: ["min"],
  message: "{_field_} có giá trị tối thiểu {min}",
});
extend("min-length", {
  params: ["min"],
  validate(value, { min }) {
    return value.length >= min;
  },
  message: "{_field_} tối thiểu {min} kí tự",
});

extend("min-length-en", {
  params: ["min"],
  validate(value, { min }) {
    return value.length >= min;
  },
  message: "{_field_} at least {min} characters",
});

extend("phone", {
  validate(value) {
    let regex = /^(0[35789]|01[2689])+([0-9]{8})$/;
    return regex.test(value);
  },
  message: "{_field_} chưa hợp lệ",
});
extend("name", {
  validate(value) {
    let regex = /^[^0-9_!@#$%^&*()\-=+{}[\]\\/\\`~?,:'"<>|]+$/;
    return regex.test(value);
  },
  message: "{_field_} không hợp lệ",
});
extend("phone_mask", {
  validate(value) {
    value = value.split(" ").join("");
    let regex = /^(0[35789]|01[2689])+([0-9]{8})$/;
    return regex.test(value);
  },
  message: "{_field_} không hợp lệ",
});
extend("phone_mask_en", {
  validate(value) {
    value = value.split(" ").join("");
    let regex = /^(0[35789]|01[2689])+([0-9]{8})$/;
    return regex.test(value);
  },
  message: "{_field_} is invalid",
});
extend("is-true", {
  validate: (value) => !!value,
  message: "{_field_} phải được đồng ý",
});
extend("confirmed", {
  ...confirmed,
  message: "{_field_} không trùng khớp",
});

const configVValidate = {
  classes: {
    valid: "is-valid",
    invalid: "is-invalid",
  },
  bails: true,
  skipOptional: true,
  mode: "aggressive",
  useConstraintAttrs: true,
};

configure(configVValidate);

Vue.component("ValidationProvider", ValidationProvider);
Vue.component("ValidationObserver", ValidationObserver);
